<template>
  <section class="body">
    <div class="row mx-0">
      <div class="col-sm-12 col-md-2"></div>
      <div class="col-sm-12 col-md-8">
        <VoteStatus :config="config" />
        <PetitionBody :petition="petition" />
      </div>
      <div class="col-sm-12 col-md-2"></div>
    </div>
  </section>
</template>

<script>
import PetitionBody from "@/components/PetitionBody.vue"
import VoteStatus from "@/components/VoteStatus.vue"

export default {
  name: 'VoteLayout',
  props: {
    config: Object
  },
  data(){
    return {
      petition: {}
    }
  },
  components: {
    PetitionBody,
    VoteStatus
  },
  methods: {
    getPetition(){
      this.axios(this.config.site_base_url + '/api/getPetition/'+this.$route.params.id)
        .then( (response) => {
          if(response){
            this.petition = response.data.petition;
          }
        })
    }
  },
  mounted() {
    this.getPetition();
  }
}
</script>

<style>
</style>
